import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import qs from 'qs';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  payorsList: [],
  payorsByStatusList: []
};
const payors = createSlice({
  name: 'payors',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        payorsList: action.payload?.data?.result,
        count: action.payload?.data?.count
      };
    },
    payorsByStatusList(state, action) {
      return {
        ...state,
        payorsByStatusList: action.payload?.data
      };
    },
    getById(state, action) {
      return {
        ...state,
        payorInfo: action.payload?.data
      };
    }
  }
});

export const payorsActions = payors.actions;

export const getPayorAction = (data) => async (dispatch) => {
  dispatch(payorsActions.setLoading(true));
  try {
    const res = await api.post(`api/Payor/Filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(payorsActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(payorsActions.setLoading(false));
  }
};

export const createPayor = (data) => async () => {
  try {
    const res = await api.post(`api/Payor`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const editPayor = (data, id) => async () => {
  try {
    const res = await api.put(`api/Payor/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const getPayorById = (id) => async (dispatch) => {
  dispatch(payorsActions.setLoading(true));
  try {
    const res = await api.get(`api/Payor/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(payorsActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(payorsActions.setLoading(false));
  }
};

export const clearPayorById = () => async (dispatch) => {
  dispatch(payorsActions.getById(''));
};

export const copyPayorLevelOfServices = (data) => async () => {
  try {
    const res = await api.post(`api/PayorLevelOfService/Copy`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const getPayorByStatusAction = (params) => async (dispatch) => {
  dispatch(payorsActions.setLoading(true));
  try {
    const res = await api.get(`api/Payor/ByStatuses`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' })
    });

    if (res.status === 200 && res?.data) {
      dispatch(payorsActions.payorsByStatusList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(payorsActions.setLoading(false));
  }
};

export const removeBillingAction = (id) => async () => {
  try {
    const res = await api.delete(`api/PayorLevelOfService/${id}`);
    if (res.status === 200 && res?.data) {
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export default payors.reducer;
